// @ts-nocheck
import React from 'react';
import makeStyles from '@mui/styles/makeStyles';
import ListItemText from '@mui/material/ListItemText';
import Typography from '@mui/material/Typography';
import DestinatariosReduced from "./DestinatariosReduced";
import {useAlias} from "./State/AliasContext";
import { useTheme } from '@mui/material/styles';

const useStyles = makeStyles(theme => ({
    inline: {
        display: 'block',
        paddingTop: '10px',
    },
    item:{
        paddingRight: '5%',
    }

}));

export default function InformacionAlias(props) {
    const {matches,aliase} = props;
    const theme = useTheme();
    const classes = useStyles();
    const {setOpenVista, setAlias, alias} =useAlias()
    /**
     * @param alias
     * Handler para seleccionar un alias sin area
     */
    const handleSetAlias = (aliase) => {
        setAlias({
            area : aliase.area? {id: aliase.area.id, nombre: aliase.area.nombre} : {id: '', nombre: ''},
            descripcion: aliase.descripcion ,
            destinatarios: aliase.destinatarios,
            mail:  aliase.mail ,
            nombre: aliase.nombre,
            visibilidadLibreta:  aliase.visibilidadLibreta
        });
        setOpenVista(true)
    }

    return (
        <>
            <ListItemText
                className={classes.item}
                primary={
                    <Typography
                    component="span"
                    variant={matches ? "h8" : "h6"}
                    className={classes.inline}
                    color="textPrimary"
                    sx={{
                      wordBreak: 'break-word',
                      whiteSpace: 'normal',
                    }}
                  >
                    {aliase.nombre + " - " + aliase.mail}
                  </Typography>
                }
                secondary={
                    <React.Fragment>
                        <Typography
                            component="span"
                            variant={matches ? "body2" : "body1"}
                            className={classes.inline}
                            color="textPrimary"
                        >
                            {aliase.descripcion}
                        </Typography>
                        <Typography
                            component="span"
                            variant="body1"
                            className={classes.inline}
                            color="textPrimary"
                        >
                            <DestinatariosReduced destinatarios={aliase.destinatarios} />
                        </Typography>
                    </React.Fragment>
                }
                secondaryTypographyProps={{component: "div"}}
                onClick={() => handleSetAlias(aliase)}
            />
        </>
    );
}